const SectionContacts = Class(
	/**
	 * @lends {SectionContacts}
	 */
	{
		bodyClass: 'full-container',
		menuItem: 'contacts',

		draw: function() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionContacts',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container fade',
						els: [
							{
								tag: 'h1',
								text: t('b2b.contacts.hero.h1')
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-4 contacts__form fade',
						els: [
							{
								tag: 'div',
								className: 'contacts__block',
								els: [
									new SectionContacts.Form({
										type: 'b2b/contacts',
										ref: this.url.get.v('ref') || null
									})
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-4 contacts__intouch fade',
						els: [
							{
								tag: 'div',
								className: 'contacts__block',
								els: [
									{
										tag: 'div',
										className: 'overline',
										text: t('b2b.contacts.in-touch.title')
									},
									{
										tag: 'div',
										className: 'row',
										els: [
											{
												tag: 'div',
												className: 'col contact-items',
												els: [
													{
														tag: 'a',
														className: 'item item--email',
														target: '_blank',
														href: 'mailto:' + D.Lang.get('b2b.contacts.email.href'),
														text: D.Lang.get('b2b.contacts.email.text')
													},
													{
														tag: 'a',
														className: 'item item--phone',
														target: '_blank',
														href: 'tel:' + D.Lang.get('b2b.contacts.phone.href'),
														text: D.Lang.get('b2b.contacts.phone.text')
													},
													{
														tag: 'a',
														className: 'item item--booking',
														target: '_blank',
														attr: {
															rel: 'nofollow'
														},
														href: D.Lang.get('b2b.contacts.booking.href'),
														text: D.Lang.get('b2b.contacts.booking.text')
													}
												]
											},
											{
												tag: 'div',
												className: 'col',
												els: [
													T.SocialIcons({title: null, text: null})
												]
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-4 contacts__addresses fade',
						els: [
							{
								tag: 'div',
								className: 'contacts__block row',
								els: [
									{
										tag: 'div',
										className: 'col',
										els: [
											{
												tag: 'div',
												className: 'title',
												text: t('b2b.contacts.address.title')
											},
											{
												tag: 'div',
												className: 'text',
												text: t('b2b.contacts.address.text')
											},
											{
												tag: 'a',
												className: 'navigate',
												text: t('b2b.contacts.address.navigate.text'),
												href: t('b2b.contacts.address.navigate.href'),
												target: '_blank',
												attr: {
													rel: 'nofollow'
												}
											}
										]
									},
									{
										tag: 'div',
										className: 'col',
										els: [
											{
												tag: 'div',
												className: 'title',
												text: t('b2b.contacts.com.title')
											},
											{
												tag: 'div',
												className: 'text',
												text: t('b2b.contacts.com.text')
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 contacts__map fade',
						els: [
							{
								tag: 'div',
								className: 'contacts__block',
								els: [
									{
										tag: 'a',
										className: 'map',
										href: t('b2b.contacts.map'),
										attr: {
											target: '_blank',
											rel: 'noopener noreferrer'
										}
									}
								]
							}
						]
					},
					new T.FAQ({
						title: D.Lang.get('b2b.contacts.faq.title'),
						prefix: 'b2b.contacts.faq',
						className: 'container mb-5 fade'
					})
				]
			}).append(this.layout.ct());

			this.ready();
		}

	},
	Section
);

/**
 * @class
 * @extends T.CorporateForm
 */
SectionContacts.Form = Class(
	/**
	 * @lends {SectionContacts.Form#}
	 */
	{
		METHOD: 'submitContactFormBusiness',
		draw() {
			let defaultParticipants = {
				value: 10,
				min: 10,
				max: 200
			};
			if (D.CSS.brTablet) {
				defaultParticipants = {
					value: null,
					min: 0,
					max: 200
				};
			}
			let els = [
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12 col-md-5',
							els: [
								this.name({
									minLength: 2,
									required: true
								})
							]
						},
						{
							tag: 'div',
							className: 'col-12 col-md-7',
							els: [
								this.email()
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12 col-md-5',
							els: [
								this.phone({
									required: false
								})
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12',
							els: [
								this.participants(defaultParticipants)
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12',
							els: [
								this.message({
									rows: 5
								})
							]
						}
					]
				},
				this.footer()
			];
			mkE.appendTypeElement(this.node, els);
		}
	},
	T.CorporateForm
);